module.exports = __webpack_public_path__ + "static/media/clock-regular.ed481c48.svg";